module.exports = __webpack_public_path__ + "static/media/house_10.9e63d191.jpg";